/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import user from '@/core/user'
import mapValues from 'lodash/mapValues'

function init() {
  let _settings = null
  let _data     = null

  if (user.get() && user.get().data) {
    _settings = user.getCompanySettings()
    _data     = user.get().data

    _data.MarketTypeID           = parseInt(_data.MarketTypeID)
    _data.MembershipPlanID       = parseInt(_data.MembershipPlanID)
    _data.ApplyPartnerCommission = user.get().hasPC
    _data.IsDell                 = user.get().isDell
  }

  const User = mapValues(Object.assign({ settings: _settings }, _data), toBool)

  const ROLE = {
    BASIC          : User.type === 'basic',
    NO_ADMIN       : true,
    REGIONAL_ADMIN : allow('RegionalAdministration'),
    COMPANY_ADMIN  : allow('Administration'),
    FULL_ADMIN     : User.type === 'admin'
  }

  const type = {
    BUYER    : User.MarketTypeID === 1,
    BS       : User.MarketTypeID === 2,
    SELLER   : User.MarketTypeID === 3
  }

  const ENTITY = {
    ENTERPRISE    : User.IsE360,
    CORPORATE     : User.IsFusion,
    SUPPLIER      : type.BS || type.SELLER,

    BASIC_BS      : type.BS    &&            !User.IsE360 && !User.IsFusion,
    ENTERPRISE_BS : type.BS    &&             User.IsE360 &&  User.MembershipPlanID === 3,
    CORPORATE_B   : type.BUYER &&             User.IsFusion,
    BASIC_B       : type.BUYER && !User.IsFusion
  }

  return {
    ROLE,
    type,
    ENTITY,
    User
  }
}

function allow(role) {
  return !~getPermissions().indexOf('deny' + role)
}

function toBool(v) {
  return v === '1' ? true : v === '0' ? false : v
}

function getPermissions() {
  const authUser = JSON.parse(window.localStorage.getItem('evedUser'))
  var permissions = []

  if (authUser && authUser.token && authUser.permissions) {
    permissions = authUser.permissions
  }

  return permissions
}

export default {
  get role()   { return init().ROLE   },
  get type()   { return init().type   },
  get entity() { return init().ENTITY },
  get user()   { return init().User }
}



// WEBPACK FOOTER //
// ./src/core/legacy-auth/users.js